import { createSlice } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import { convertArrayToObject } from "../../helpers/catalog-helper";
import { userNormalLogout, supportLogout } from "../actions";

export interface ChargesAndDiscountsState {
  discountsData: {};
  chargesDataMap: {};
  allDiscounts: Record<string, any>;
}

const initialState: ChargesAndDiscountsState = {
  discountsData: {},
  chargesDataMap: {},
  allDiscounts: {},
}

export const chargesAndDiscountsSlice = createSlice({
  name: 'chargesAndDiscounts',
  initialState,
  reducers: {
    getDiscountsData: (state, actions) => { },
    saveDiscountsData: (state, actions) => {
      state.discountsData = actions.payload
    },
    getSingleDiscountData: (state, actions) => { },
    deleteSingleDiscount: (state, actions) => { },
    addDiscount: (state, actions) => {},
    getAllDiscounts: (state) => { },
    saveAllDiscounts: (state, actions) => {
      state.allDiscounts = convertArrayToObject(actions.payload, 'mid');
    },
    getAllChargesData: (state) => { },
    saveChargesData: (state, actions) => {
      state.chargesDataMap = actions.payload?convertArrayToObject(actions.payload):{};
    },
    deleteSingleCharge: (state, actions) => { },
    addCharge: (state, actions) => {},
    updateChargesList:  (state, actions) => {
      let dataToUpdate:any = cloneDeep(state.chargesDataMap);
      dataToUpdate[actions.payload.key] = actions.payload.data;
      state.chargesDataMap = dataToUpdate;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(userNormalLogout, () => initialState)
      .addCase(supportLogout, () => initialState);
  },
});

export const {
  getDiscountsData,
  saveDiscountsData,
  getSingleDiscountData,
  deleteSingleDiscount,
  addDiscount,
  saveAllDiscounts,
  getAllDiscounts,
  getAllChargesData,
  saveChargesData,
  deleteSingleCharge,
  addCharge,
  updateChargesList
} = chargesAndDiscountsSlice.actions;
export default chargesAndDiscountsSlice.reducer;